'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'compass-drafting';
var width = 512;
var height = 512;
var aliases = ["drafting-compass"];
var unicode = 'f568';
var svgPathData = 'M304 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-19.6 91.7c-9 2.8-18.5 4.3-28.4 4.3s-19.4-1.5-28.4-4.3L158.1 306.4c29.7 13.9 62.9 21.6 97.9 21.6 85.8 0 160.8-46.6 201-116 6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8c-48.4 83.6-138.9 140-242.5 140-43.8 0-85.3-10.1-122.2-28L44.7 500.1c-6.7 11.4-21.4 15.3-32.8 8.6s-15.3-21.4-8.6-32.8L92.6 323.4c-32.1-23.1-59.2-52.9-79.1-87.4-6.6-11.5-2.7-26.2 8.8-32.8S48.4 200.5 55 212c15.8 27.2 36.9 51 61.9 69.7l69.8-119.2C170.2 145.2 160 121.8 160 96 160 43 203 0 256 0s96 43 96 96c0 25.8-10.2 49.2-26.7 66.5L370.6 240c-12.5 10-26.3 18.3-41.1 24.8l-45.1-77zM508.7 475.9c6.7 11.4 2.9 26.1-8.6 32.8s-26.1 2.9-32.8-8.6L402.5 389.5c14.4-7.2 28.2-15.4 41.2-24.6l64.9 110.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompassDrafting = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;